import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import axios from 'axios';

// Create cache validation timestamp just once
// and use that for all requests
var cv = Math.floor(Date.now() / 1000);
export default (function (_ref, inject) {
  var $config = _ref.$config;
  var token = $config.STORYBLOK_TOKEN;
  var configsByCountry = {};
  inject('storyblok', {
    getAppConfig: function getAppConfig(country) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var relations;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              relations = ['activation_nagger_logos', 'subscribe_modal_quotes', 'subscribe_modal_logo_cloud'];
              if (configsByCountry[country]) {
                _context.next = 12;
                break;
              }
              _context.prev = 2;
              _context.next = 5;
              return axios.get("https://api.storyblok.com/v2/cdn/stories/data/app-config-".concat(country.toLowerCase()), {
                params: {
                  token: token,
                  cv: cv,
                  resolve_relations: relations.join(',')
                }
              }).then(function (r) {
                return resolveRelations(r.data, relations).story;
              });
            case 5:
              configsByCountry[country] = _context.sent;
              _context.next = 12;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);
              // eslint-disable-next-line no-console
              console.error(_context.t0);
              return _context.abrupt("return", null);
            case 12:
              return _context.abrupt("return", configsByCountry[country]);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 8]]);
      }))();
    }
  });
});
function resolveRelations(config, relations) {
  relations.forEach(function (relation) {
    var target = config.story.content[relation];
    if (Array.isArray(target)) {
      config.story.content[relation] = target.map(function (uuid) {
        return config.rels.find(function (rel) {
          return rel.uuid === uuid;
        }) || uuid;
      });
    }
  });
  return config;
}